export const SharedCandidatesStatusesEnum = {
  Pending: {
    key: "pending",
    value: "pending",
    label: "pending",
    countKey: "pending",
  },
  Confirmed: {
    key: "recommended",
    value: "recommended",
    label: "recommended",
    countKey: "recommended",
  },
  Expired: {
    key: "not-recommended",
    value: "not-recommended",
    label: "not-recommended",
    countKey: "not_recommended",
  },
};
